/* ==========================================================================
   MAYF Home — theme behaviour
   Everything here exists to remove friction: fewer page loads, instant
   feedback on every tap, and no state the shopper has to hold in their head.
   ========================================================================== */
(function () {
  'use strict';

  var MAYF = window.MAYF || {};

  /* ---------------------------------------------------------------- utils */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    var format = MAYF.moneyFormat || 'AED {{amount}}';
    var amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
    var withCommas = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format
      .replace(/\{\{\s*amount\s*\}\}/, withCommas)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toLocaleString('en-US'))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withCommas)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(cents / 100).toLocaleString('en-US'));
  }

  var scrollLocks = 0;
  function lockScroll(on) {
    scrollLocks = Math.max(0, scrollLocks + (on ? 1 : -1));
    document.documentElement.classList.toggle('scroll-lock', scrollLocks > 0);
    document.body.classList.toggle('scroll-lock', scrollLocks > 0);
  }

  var toastTimer;
  function toast(message) {
    var el = document.getElementById('Toast');
    if (!el) return;
    el.textContent = message;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 2800);
  }

  function trapFocus(container) {
    var selector = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';
    function onKey(e) {
      if (e.key !== 'Tab') return;
      var focusable = $$(selector, container).filter(function (el) { return el.offsetParent !== null; });
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    container.addEventListener('keydown', onKey);
    return function () { container.removeEventListener('keydown', onKey); };
  }

  /* ------------------------------------------------------------- cart api */
  var Cart = {
    listeners: [],

    onChange: function (fn) { this.listeners.push(fn); },

    notify: function (state) {
      this.listeners.forEach(function (fn) { fn(state); });
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: state }));
    },

    add: function (formData) {
      return fetch(MAYF.routes.cartAdd, {
        method: 'POST',
        headers: { Accept: 'application/javascript' },
        body: formData
      })
        .then(function (res) { return res.json().then(function (body) { return { ok: res.ok, body: body }; }); })
        .then(function (result) {
          if (!result.ok) throw new Error(result.body.description || result.body.message || MAYF.strings.cartError);
          return Cart.get();
        });
    },

    change: function (line, quantity) {
      return fetch(MAYF.routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (res) { return res.json(); })
        .then(function (state) { Cart.notify(state); return state; });
    },

    get: function () {
      return fetch(MAYF.routes.cart + '.js', { headers: { Accept: 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (state) { Cart.notify(state); return state; });
    }
  };

  window.MAYFCart = Cart;

  /* --------------------------------------------------------- header count */
  Cart.onChange(function (state) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = state.item_count;
      el.hidden = state.item_count === 0;
    });
  });

  /* --------------------------------------------------------- mobile menu */
  function initMobileNav() {
    var nav = $('[data-mobile-nav]');
    if (!nav) return;
    var release;

    function open() {
      nav.classList.add('is-open');
      nav.setAttribute('aria-hidden', 'false');
      lockScroll(true);
      release = trapFocus(nav);
      var focusTarget = $('[data-mobile-nav-close]', nav);
      if (focusTarget) focusTarget.focus();
    }

    function close() {
      nav.classList.remove('is-open');
      nav.setAttribute('aria-hidden', 'true');
      lockScroll(false);
      if (release) release();
    }

    $$('[data-mobile-nav-open]').forEach(function (btn) { btn.addEventListener('click', open); });
    $$('[data-mobile-nav-close]', nav).forEach(function (btn) { btn.addEventListener('click', close); });
    $('.mobile-nav__overlay', nav).addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) close();
    });
  }

  /* --------------------------------------------------------- cart drawer */
  function initCartDrawer() {
    var drawer = $('[data-cart-drawer]');
    if (!drawer) return;
    var release;

    function open() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      lockScroll(true);
      release = trapFocus(drawer);
      var close = $('[data-drawer-close]', drawer);
      if (close) close.focus();
    }

    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      lockScroll(false);
      if (release) release();
    }

    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-drawer-close]') || e.target.classList.contains('drawer__overlay')) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });

    $$('[data-cart-drawer-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        refresh().then(open);
      });
    });

    function refresh() {
      return fetch(MAYF.routes.cart + '?section_id=cart-drawer', { headers: { Accept: 'text/html' } })
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var next = parsed.querySelector('[data-drawer-inner]');
          var current = $('[data-drawer-inner]', drawer);
          if (next && current) current.innerHTML = next.innerHTML;
        });
    }

    document.addEventListener('cart:open-drawer', function () { refresh().then(open); });
    document.addEventListener('cart:updated', function () {
      if (drawer.classList.contains('is-open')) refresh();
    });

    // Quantity + remove inside the drawer, without a page load.
    drawer.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-line-change]');
      if (!btn) return;
      e.preventDefault();
      var line = btn.getAttribute('data-line');
      var qty = parseInt(btn.getAttribute('data-line-change'), 10);
      btn.disabled = true;
      Cart.change(line, qty).then(refresh);
    });
  }

  /* --------------------------------------------------- add to cart forms */
  function initProductForms() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-product-form]');
      if (!form) return;
      e.preventDefault();

      var button = form.querySelector('[type="submit"]');
      var errorEl = form.querySelector('[data-form-error]');
      if (errorEl) errorEl.hidden = true;
      if (button) button.classList.add('btn--loading');

      Cart.add(new FormData(form))
        .then(function () {
          if (MAYF.cartDrawer) document.dispatchEvent(new CustomEvent('cart:open-drawer'));
          else toast(MAYF.strings.added);
        })
        .catch(function (err) {
          if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
          else toast(err.message);
        })
        .finally(function () { if (button) button.classList.remove('btn--loading'); });
    });
  }

  /* ------------------------------------------------------------ quantity */
  function initQuantity() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty-change]');
      if (!btn) return;
      var wrap = btn.closest('.qty');
      var input = wrap && wrap.querySelector('input');
      if (!input) return;
      var step = parseInt(btn.getAttribute('data-qty-change'), 10);
      var min = parseInt(input.getAttribute('min') || '1', 10);
      var next = Math.max(min, (parseInt(input.value, 10) || min) + step);
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ------------------------------------------------------- media gallery */
  function initGallery() {
    $$('[data-gallery]').forEach(function (gallery) {
      var slides = $$('[data-gallery-slide]', gallery);
      var thumbs = $$('[data-gallery-thumb]', gallery);

      function show(index) {
        slides.forEach(function (slide, i) {
          slide.classList.toggle('is-active', i === index);
          slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
        });
        thumbs.forEach(function (thumb, i) {
          thumb.setAttribute('aria-current', i === index ? 'true' : 'false');
        });
      }

      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function () { show(i); });
      });

      // Variant changes bring the matching image forward automatically.
      gallery.addEventListener('variant:media', function (e) {
        var id = String(e.detail.mediaId);
        var index = slides.findIndex(function (slide) { return slide.getAttribute('data-media-id') === id; });
        if (index > -1) show(index);
      });
    });
  }

  /* -------------------------------------------------------------- tabs */
  function initTabs() {
    $$('[data-tabs]').forEach(function (root) {
      var tabs = $$('[role="tab"]', root);
      var panels = $$('[role="tabpanel"]', root);

      function select(index) {
        tabs.forEach(function (tab, i) {
          tab.setAttribute('aria-selected', i === index ? 'true' : 'false');
          tab.tabIndex = i === index ? 0 : -1;
        });
        panels.forEach(function (panel, i) { panel.hidden = i !== index; });
      }

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { select(i); });
        tab.addEventListener('keydown', function (e) {
          var dir = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!dir) return;
          e.preventDefault();
          var next = (i + dir + tabs.length) % tabs.length;
          tabs[next].focus();
          select(next);
        });
      });

      select(0);
    });
  }

  /* ---------------------------------------------------------- carousels */
  function initCarousels() {
    $$('[data-carousel]').forEach(function (root) {
      var track = $('[data-carousel-track]', root);
      var prev = $('[data-carousel-prev]', root);
      var next = $('[data-carousel-next]', root);
      if (!track) return;

      function step() {
        var first = track.firstElementChild;
        return first ? first.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
      }

      function update() {
        var max = track.scrollWidth - track.clientWidth - 2;
        var atStart = track.scrollLeft <= 2;
        var atEnd = Math.abs(track.scrollLeft) >= max;
        if (prev) prev.hidden = atStart;
        if (next) next.hidden = atEnd || max <= 0;
      }

      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ------------------------------------------------------- sticky buy bar */
  function initStickyBuy() {
    var bar = $('[data-sticky-buy]');
    var anchor = $('[data-buy-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;

    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { rootMargin: '0px' }).observe(anchor);

    var trigger = $('[data-sticky-buy-trigger]', bar);
    if (trigger) {
      trigger.addEventListener('click', function () {
        var form = $('[data-product-form]');
        if (form) form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      });
    }
  }

  /* ------------------------------------------------------------- facets */
  function initFacets() {
    var form = $('[data-facet-form]');
    var results = $('[data-collection-results]');
    if (!form || !results) return;

    var toggle = $('[data-facets-toggle]');
    var panel = $('[data-facets-panel]');

    if (toggle && panel) {
      toggle.addEventListener('click', function () {
        var open = panel.classList.toggle('is-open');
        lockScroll(open);
      });
      $$('[data-facets-close]', panel).forEach(function (btn) {
        btn.addEventListener('click', function () {
          panel.classList.remove('is-open');
          lockScroll(false);
        });
      });
    }

    function render(url) {
      results.setAttribute('aria-busy', 'true');
      fetch(url, { headers: { Accept: 'text/html' } })
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          ['[data-collection-results]', '[data-facet-form]'].forEach(function (sel) {
            var next = parsed.querySelector(sel);
            var current = $(sel);
            if (next && current) current.innerHTML = next.innerHTML;
          });
          window.history.replaceState({}, '', url);
          results.removeAttribute('aria-busy');
          results.scrollIntoView({ behavior: 'smooth', block: 'start' });
        })
        .catch(function () { window.location.href = url; });
    }

    form.addEventListener('change', function () {
      var params = new URLSearchParams();
      new FormData(form).forEach(function (value, key) {
        if (String(value).trim() !== '') params.append(key, value);
      });

      var sort = $('[data-sort]');
      if (sort && sort.value) params.set('sort_by', sort.value);

      var query = params.toString();
      render(window.location.pathname + (query ? '?' + query : ''));
    });

    document.addEventListener('click', function (e) {
      var link = e.target.closest('[data-facet-link]');
      if (!link) return;
      e.preventDefault();
      render(link.href);
    });

    var sort = $('[data-sort]');
    if (sort) {
      sort.addEventListener('change', function () {
        var params = new URLSearchParams(window.location.search);
        params.set('sort_by', sort.value);
        render(window.location.pathname + '?' + params.toString());
      });
    }
  }

  /* --------------------------------------------------------- countdown */
  function initCountdown() {
    $$('[data-countdown]').forEach(function (el) {
      var cutoffHour = parseInt(el.getAttribute('data-cutoff-hour'), 10);
      var offset = parseFloat(el.getAttribute('data-utc-offset') || '4');
      var target = el.querySelector('[data-countdown-value]') || el;

      function tick() {
        var now = new Date();
        var storeNow = new Date(now.getTime() + (offset * 60 + now.getTimezoneOffset()) * 60000);
        var cutoff = new Date(storeNow);
        cutoff.setHours(cutoffHour, 0, 0, 0);
        if (cutoff <= storeNow) { el.hidden = true; return; }

        var diff = Math.floor((cutoff - storeNow) / 1000);
        var h = Math.floor(diff / 3600);
        var m = Math.floor((diff % 3600) / 60);
        var s = diff % 60;
        target.textContent = (h > 0 ? h + 'h ' : '') + m + 'm ' + (h > 0 ? '' : s + 's');
        el.hidden = false;
      }

      tick();
      setInterval(tick, 1000);
    });
  }

  /* ----------------------------------------------------- shipping progress */
  function initShippingBar() {
    function paint(state) {
      var threshold = MAYF.freeShippingThreshold;
      $$('[data-shipping-bar]').forEach(function (bar) {
        if (!threshold) { bar.hidden = true; return; }
        var total = state ? state.total_price : parseInt(bar.getAttribute('data-cart-total'), 10) || 0;
        var remaining = Math.max(0, threshold - total);
        var fill = bar.querySelector('[data-shipping-fill]');
        var text = bar.querySelector('[data-shipping-text]');
        if (fill) fill.style.width = Math.min(100, (total / threshold) * 100) + '%';
        if (text) {
          text.innerHTML = remaining > 0
            ? text.getAttribute('data-remaining-text').replace('__AMOUNT__', '<strong>' + formatMoney(remaining) + '</strong>')
            : text.getAttribute('data-reached-text');
        }
      });
    }

    paint(null);
    Cart.onChange(paint);
  }

  /* ------------------------------------------------------------ variants */
  function initVariantPickers() {
    $$('[data-variant-picker]').forEach(function (picker) {
      var section = picker.closest('[data-product-section]') || document;
      var variants = JSON.parse($('[data-variant-json]', section).textContent);
      var form = $('[data-product-form]', section);
      var idInput = form && form.querySelector('[name="id"]');

      function selectedOptions() {
        return $$('input:checked', picker).map(function (input) { return input.value; });
      }

      function update() {
        var chosen = selectedOptions();

        // Grey out combinations that do not exist rather than hiding them —
        // the shopper keeps a stable mental map of the full range.
        $$('[data-option-index]', picker).forEach(function (input) {
          var index = parseInt(input.getAttribute('data-option-index'), 10);
          var probe = chosen.slice();
          probe[index] = input.value;
          var match = variants.find(function (v) {
            return probe.every(function (value, i) { return value === undefined || v.options[i] === value; });
          });
          var available = match && match.available;
          input.closest('.variant-option').classList.toggle('variant-option--unavailable', !available);
        });

        var variant = variants.find(function (v) {
          return chosen.every(function (value, i) { return v.options[i] === value; });
        });

        $$('[data-option-value]', picker).forEach(function (el) {
          var index = parseInt(el.getAttribute('data-option-value'), 10);
          el.textContent = chosen[index] || '';
        });

        var button = $('[data-add-button]', section);
        var priceEl = $('[data-price-block]', section);

        if (!variant) {
          if (button) { button.disabled = true; button.textContent = MAYF.strings.unavailable; }
          return;
        }

        if (idInput) idInput.value = variant.id;

        if (button) {
          button.disabled = !variant.available;
          button.textContent = variant.available ? MAYF.strings.addToCart : MAYF.strings.soldOut;
        }

        if (priceEl) {
          fetch(window.location.pathname + '?variant=' + variant.id + '&section_id=' + section.getAttribute('data-section-id'), { headers: { Accept: 'text/html' } })
            .then(function (res) { return res.text(); })
            .then(function (html) {
              var parsed = new DOMParser().parseFromString(html, 'text/html');
              ['[data-price-block]', '[data-stock-block]', '[data-sticky-price]'].forEach(function (sel) {
                var next = parsed.querySelector(sel);
                var current = $(sel, section) || $(sel);
                if (next && current) current.innerHTML = next.innerHTML;
              });
            });
        }

        if (variant.featured_media) {
          var gallery = $('[data-gallery]', section);
          if (gallery) gallery.dispatchEvent(new CustomEvent('variant:media', { detail: { mediaId: variant.featured_media.id } }));
        }

        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }

      picker.addEventListener('change', update);
      update();
    });
  }

  /* ------------------------------------------------------------ cart page */
  function initCartPage() {
    var page = $('[data-cart-page]');
    if (!page) return;

    var sectionId = page.getAttribute('data-section-id');

    function refresh() {
      fetch(window.location.pathname + '?section_id=' + sectionId, { headers: { Accept: 'text/html' } })
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var next = parsed.querySelector('[data-cart-page]');
          if (next) page.innerHTML = next.innerHTML;
          Cart.get();
        });
    }

    page.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-line-change]');
      if (!btn) return;
      e.preventDefault();
      btn.disabled = true;
      Cart.change(btn.getAttribute('data-line'), parseInt(btn.getAttribute('data-line-change'), 10)).then(refresh);
    });

    page.addEventListener('change', function (e) {
      var input = e.target.closest('[data-line-qty]');
      if (!input) return;
      Cart.change(input.getAttribute('data-line'), parseInt(input.value, 10)).then(refresh);
    });
  }

  /* --------------------------------------------------------------- init */
  function init() {
    initMobileNav();
    initCartDrawer();
    initProductForms();
    initQuantity();
    initGallery();
    initTabs();
    initCarousels();
    initStickyBuy();
    initFacets();
    initCountdown();
    initShippingBar();
    initVariantPickers();
    initCartPage();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Theme editor re-renders sections without a page load.
  document.addEventListener('shopify:section:load', init);
})();
